class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.isRemovingFilter = false;

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    
    this.addEventListener('click', this.handleFilterRemove.bind(this));
    
    setTimeout(() => this.openActiveFilterBlocks(), 100);
  }

  openActiveFilterBlocks() {
    const activeFilters = document.querySelectorAll('.active-facets__button-inner');
    if (activeFilters.length === 0) return;
    
    const activeFilterLabels = new Set();
    activeFilters.forEach(filter => {
      const filterText = filter.textContent || '';
      if (filterText.includes(':')) {
        const [label] = filterText.split(':');
        activeFilterLabels.add(label.trim().toLowerCase());
      }
    });
    
    document.querySelectorAll('.facets__disclosure-vertical').forEach(filterBlock => {
      const summary = filterBlock.querySelector('.facets__summary');
      if (!summary) return;
      
      const labelElement = summary.querySelector('span span:first-child');
      if (!labelElement) return;
      
      const blockLabel = labelElement.textContent.trim().toLowerCase();
      
      if (activeFilterLabels.has(blockLabel)) {
        filterBlock.setAttribute('open', '');
        
        const display = filterBlock.querySelector('.facets__display-vertical');
        if (display) {
          display.classList.add('is-open');
          display.style.display = 'block';
          display.style.maxHeight = 'none';
          display.style.opacity = '1';
          
          summary.classList.add('is-open');
        }
      }
    });
  }

  handleFilterRemove(event) {
    const filterRemoveLink = event.target.closest('facet-remove a, .active-facets__button-inner, .js-facet-remove a');
    if (filterRemoveLink) {
      event.preventDefault();
      event.stopPropagation();
      this.onActiveFilterClick(event);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const productGridContainer = document.getElementById('ProductGridContainer');
    
    if (productGridContainer) {
      const collectionElement = productGridContainer.querySelector('.collection');
      if (collectionElement) {
        collectionElement.classList.add('loading');
      }
    }
    
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    
    setTimeout(() => {
      const form = document.querySelector('facet-filters-form');
      if (form && form.openActiveFilterBlocks) {
        form.openActiveFilterBlocks();
      }
    }, 300);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch(error => {
        console.error('Error fetching section:', error);
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        const productGridContainer = document.getElementById('ProductGridContainer');
        
        if (countContainer) countContainer.classList.remove('loading');
        if (countContainerDesktop) countContainerDesktop.classList.remove('loading');
        if (productGridContainer) {
          const collectionElement = productGridContainer.querySelector('.collection');
          if (collectionElement) collectionElement.classList.remove('loading');
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    if (!container) {
      console.error('ProductGridContainer not found');
      return;
    }
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newContent = parsedHTML.getElementById('ProductGridContainer');
    
    if (newContent) {
      container.innerHTML = newContent.innerHTML;
    
      reinitFacetToggles();
      initViewToggles();
      initMobileFilters();
      initProductLoading();
      filterNewProducts();

      // Apply color matching to the container
      applyColorMatching(container);

      container
        .querySelectorAll('.scroll-trigger')
        .forEach((element) => {
          element.classList.add('scroll-trigger--cancel');
        });
    }
  }

  static renderProductCount(html) {
    try {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const countElement = parsedHTML.getElementById('ProductCount');
      
      if (countElement) {
        const count = countElement.innerHTML;
        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        
        if (container) {
          container.innerHTML = count;
          container.classList.remove('loading');
        }
        if (containerDesktop) {
          containerDesktop.innerHTML = count;
          containerDesktop.classList.remove('loading');
        }
      }
    } catch (error) {
      console.error('Error rendering product count:', error);
      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      if (countContainer) countContainer.classList.remove('loading');
      if (countContainerDesktop) countContainerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    try {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      const facetDetailsElements =
        parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
      const matchesIndex = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
      }
      const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
      const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

      facetsToRender.forEach((element) => {
        const targetElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
        if (targetElement) {
          targetElement.innerHTML = element.innerHTML;
        }
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      if (countsToRender) {
        const targetFilter = event ? event.target.closest('.js-filter') : null;
        if (targetFilter) {
          FacetFiltersForm.renderCounts(countsToRender, targetFilter);
        }
      }
    } catch (error) {
      console.error('Error rendering filters:', error);
    }
  }

  static renderActiveFacets(parsedHTML) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = parsedHTML.querySelector(selector);
      if (!activeFacetsElement) return;
      
      const targetElement = document.querySelector(selector);
      if (targetElement) {
        targetElement.innerHTML = activeFacetsElement.innerHTML;
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    try {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

      mobileElementSelectors.forEach((selector) => {
        const sourceElement = parsedHTML.querySelector(selector);
        if (!sourceElement) return;
        
        const targetElement = document.querySelector(selector);
        if (targetElement) {
          targetElement.innerHTML = sourceElement.innerHTML;
        }
      });

      const mobileForm = document.getElementById('FacetFiltersFormMobile');
      if (mobileForm) {
        const menuDrawer = mobileForm.closest('menu-drawer');
        if (menuDrawer && menuDrawer.bindEvents) {
          menuDrawer.bindEvents();
        }
      }
    } catch (error) {
      console.error('Error rendering additional elements:', error);
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    if (productGrid && productGrid.dataset.id) {
      return [
        {
          section: productGrid.dataset.id,
        }
      ];
    }
    return [];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if (this.isRemovingFilter) return;
    
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const form = event.target.closest('form');
    const isMobile = form && form.id === 'FacetFiltersFormMobile';

    const mergedParams = new URLSearchParams(window.location.search);

    sortFilterForms.forEach((formElement) => {
      const formData = new FormData(formElement);

      const shouldIncludeForm =
        (!isMobile && ['FacetSortForm', 'FacetFiltersForm', 'FacetSortDrawerForm'].includes(formElement.id)) ||
        (isMobile && formElement.id === 'FacetFiltersFormMobile');

      if (shouldIncludeForm) {
        for (let [key, value] of formData.entries()) {
          if ((key === 'filter.v.price.gte' || key === 'filter.v.price.lte') && !value) {
            continue;
          }          
          if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
            mergedParams.set(key, value);
          } else {
            mergedParams.append(key, value);
          }
        }
      }
    });

    // filter checked color value
    const selectedColors = [...document.querySelectorAll('.custom-color input:checked')]
      .map(input => input.value.replace(/\s*\(.*?\)\s*/, '').trim());

    sessionStorage.setItem('selectedFilterColors', JSON.stringify(selectedColors));

    this.onSubmitForm(mergedParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.isRemovingFilter) return;
    this.isRemovingFilter = true;
    
    if (this.debouncedOnSubmit && this.debouncedOnSubmit.cancel) {
      this.debouncedOnSubmit.cancel();
    }
    
    const clickedElement = event.target.closest('a') || event.currentTarget;
    const activeFacetInner = clickedElement.querySelector('.active-facets__button-inner') || 
                            clickedElement.closest('.active-facets__button-inner');
    
    if (!clickedElement || !activeFacetInner) {
      console.error('No valid element found');
      this.isRemovingFilter = false;
      return;
    }
    
    try {
      FacetFiltersForm.toggleActiveFacets(true);
      
      const currentParams = new URLSearchParams(window.location.search);
      
      console.log('Current params before removal:', currentParams.toString());
      
      const dataValue = activeFacetInner.getAttribute('data-value');
      console.log('data-value attribute:', dataValue);
      
      if (!dataValue) {
        // console.error('No data-value attribute found on filter pill');
        // this.isRemovingFilter = false;
        // return;        
        if (currentParams.get('filter.v.price.gte') || currentParams.get('filter.v.price.lte')) {
          currentParams.delete('filter.v.price.gte');
          currentParams.delete('filter.v.price.lte');

          const searchParams = currentParams.toString();
          FacetFiltersForm.renderPage(searchParams, event);
        }

        this.isRemovingFilter = false;
        return;
      }
      
      let paramToRemove = null;
      let valueToRemove = null;
      
      for (const [paramName, paramValue] of currentParams.entries()) {
        if (paramName.includes('filter.')) {
          const paramValueHandle = paramValue.toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
          
          if (paramValueHandle === dataValue) {
            paramToRemove = paramName;
            valueToRemove = paramValue;
            console.log(`Found matching filter: ${paramName}=${paramValue}`);
            break;
          }
        }
      }
      
      // if (!paramToRemove) {
      //   console.log('Could not find matching filter, trying to parse from text...');
        
      //   const tempElement = activeFacetInner.cloneNode(true);
      //   tempElement.querySelectorAll('svg, .visually-hidden').forEach(el => el.remove());
      //   const filterText = tempElement.textContent.trim();
        
      //   if (filterText.includes(':')) {
      //     const [filterLabel, filterValue] = filterText.split(':');
      //     const cleanLabel = filterLabel.trim();
      //     const cleanValue = filterValue.replace('✕', '').trim();
          
      //     console.log('Parsed from text:', cleanLabel, '=', cleanValue);
          
      //     const labelMap = {
      //       'Style': 'filter.p.m.custom.style',
      //       'Product type': 'filter.p.m.custom.product_type',
      //       'Category': 'filter.p.product_type',
      //       'Color': 'filter.p.m.custom.color',
      //       'Size': 'filter.p.m.custom.size'
      //     };
          
      //     paramToRemove = labelMap[cleanLabel] || `filter.p.m.custom.${cleanLabel.toLowerCase().replace(/\s+/g, '_')}`;
      //     valueToRemove = cleanValue;
      //   }
      // }
      if (!paramToRemove) {
        console.log('Could not find matching filter, trying to parse from text...');
        
        const tempElement = activeFacetInner.cloneNode(true);
        tempElement.querySelectorAll('svg, .visually-hidden').forEach(el => el.remove());
        const filterText = tempElement.textContent.trim();
        
        if (filterText.includes(':')) {
          const [filterLabel, filterValue] = filterText.split(':');
          const cleanLabel = filterLabel.trim();
          const cleanValue = filterValue.replace('✕', '').trim();
          
          console.log('Parsed from text:', cleanLabel, '=', cleanValue);
          
          const labelMap = {
            'Style': 'filter.p.m.custom.style',
            'Product type': 'filter.p.m.custom.product_type',
            'Category': 'filter.p.product_type',
            'Color': 'filter.p.m.custom.color',
            'Size': 'filter.p.m.custom.size'
          };
          
          paramToRemove = labelMap[cleanLabel] || `filter.p.m.custom.${cleanLabel.toLowerCase().replace(/\s+/g, '_')}`;
          valueToRemove = cleanValue;
        }

        // Fallback
        if (!paramToRemove) {
          console.log('Fallback: using URL from link');

          const link = event.target.closest('a');

          if (link && link.href) {
            const url = new URL(link.href);
            const searchParams = url.searchParams.toString();

            FacetFiltersForm.renderPage(searchParams, event);
            this.isRemovingFilter = false;
            return;
          }
        }
      }
      
      if (paramToRemove && valueToRemove) {
        const currentValues = currentParams.getAll(paramToRemove);
        const newValues = currentValues.filter(v => v !== valueToRemove);
        
        console.log(`Removing ${valueToRemove} from ${paramToRemove}`);
        console.log('Current values:', currentValues, 'New values:', newValues);
        
        currentParams.delete(paramToRemove);
        newValues.forEach(v => {
          if (v) currentParams.append(paramToRemove, v);
        });
        
        if (newValues.length === 0) {
          currentParams.delete(paramToRemove);
        }
      } else {
        console.error('Could not determine which filter to remove');
        this.isRemovingFilter = false;
        return;
      }
      
      if (!currentParams.get('filter.v.price.gte')) {
        currentParams.delete('filter.v.price.gte');
      }
      if (!currentParams.get('filter.v.price.lte')) {
        currentParams.delete('filter.v.price.lte');
      }
      
      const searchParams = currentParams.toString();
      
      console.log('Final params after removal:', searchParams);
      
      FacetFiltersForm.renderPage(searchParams, event);
      
    } catch (error) {
      console.error('Filter removal error:', error);
      this.isRemovingFilter = false;
    }
  }
}

// Apply color matching based on selected color filter
function applyColorMatching(container) {
  const selectedColors = JSON.parse(sessionStorage.getItem('selectedFilterColors') || '[]');
  if (!selectedColors.length) return;
  
  const swatches = container.querySelectorAll('.product-colors-swatch');
  const productSwatches = {};
  
  swatches.forEach((swatch) => {
    const productItem = swatch.closest('.grid__item');
    if (!productItem) return;
    
    const productId = productItem.dataset.productId || 
                     productItem.id || 
                     productItem.querySelector('a[href*="/products/"]')?.getAttribute('href') || 
                     Math.random().toString();
    
    if (!productSwatches[productId]) productSwatches[productId] = [];
    productSwatches[productId].push(swatch);
  });
  
  Object.values(productSwatches).forEach((productSwatchList) => {
    let exactMatchFound = false;
    
    productSwatchList.forEach((swatch) => {
      if (exactMatchFound) return;
      const title = swatch.getAttribute('title').toLowerCase().trim();
      if (selectedColors.some(color => title === color.trim().toLowerCase())) {
        swatch.click();
        exactMatchFound = true;
      }
    });
    
    if (!exactMatchFound) {
      let containsMatchFound = false;
      const sortedColors = [...selectedColors].sort((a, b) => {
        const partsA = a.trim().toLowerCase().split('-').length;
        const partsB = b.trim().toLowerCase().split('-').length;
        if (partsA === 2 && partsB !== 2) return -1;
        if (partsA !== 2 && partsB === 2) return 1;
        if (partsA === 3 && partsB !== 3) return -1;
        if (partsA !== 3 && partsB === 3) return 1;
        return 0;
      });
      
      productSwatchList.forEach((swatch) => {
        if (containsMatchFound) return;
        const title = swatch.getAttribute('title').toLowerCase().trim();
        if (sortedColors.some(color => title.includes(color.trim().toLowerCase()))) {
          swatch.click();
          containsMatchFound = true;
        }
      });
      
      if (!containsMatchFound) {
        productSwatchList.forEach((swatch) => {
          const title = swatch.getAttribute('title').toLowerCase().trim();
          if (selectedColors.some(color => title.includes(color.trim().toLowerCase()))) {
            swatch.click();
          }
        });
      }
    }
  });
}

function toggleFacet(facetSummary) {
  facetSummary.classList.toggle('is-open');
  
  const facetDisplay = facetSummary.nextElementSibling;
  
  if (facetDisplay && facetDisplay.classList.contains('facets__display-vertical')) {
    if (facetDisplay.classList.contains('is-open')) {
      facetDisplay.style.maxHeight = facetDisplay.scrollHeight + 'px';
      facetDisplay.offsetHeight;
      facetDisplay.style.maxHeight = '0';
      facetDisplay.style.opacity = '0';
      
      setTimeout(() => {
        facetDisplay.classList.remove('is-open');
        facetDisplay.style.display = 'none';
      }, 300);
    } else {
      facetDisplay.classList.add('is-open');
      facetDisplay.style.display = 'block';
      facetDisplay.style.maxHeight = '0';
      facetDisplay.style.opacity = '0';
      
      facetDisplay.offsetHeight;
      
      facetDisplay.style.maxHeight = facetDisplay.scrollHeight + 'px';
      facetDisplay.style.opacity = '1';
      
      setTimeout(() => {
        if (facetDisplay.classList.contains('is-open')) {
          facetDisplay.style.maxHeight = 'none';
        }
      }, 350);
    }
  }
}

function initFacetToggles() {
  document.removeEventListener('click', handleFacetClick);
  document.addEventListener('click', handleFacetClick);
}

function handleFacetClick(e) {
  const facetSummary = e.target.closest('.facets__disclosure-vertical .facets__summary');
  
  if (facetSummary) {
    e.stopPropagation();
    e.preventDefault();
    toggleFacet(facetSummary);
    return false;
  }

  if (e.target.closest('.facets__display-vertical')) {
    e.stopPropagation();
  }
}

function reinitFacetToggles() {
  document.querySelectorAll('.facets__disclosure-vertical').forEach(facet => {
    const display = facet.querySelector('.facets__display-vertical');
    const summary = facet.querySelector('.facets__summary');

    if (!display || !summary) return;

    // ✅ FORCE OPEN facets that have selected filters
    const hasChecked = display.querySelector('input:checked');
    const hasPriceValue = display.querySelector('input[name="filter.v.price.gte"]')?.value ||
                          display.querySelector('input[name="filter.v.price.lte"]')?.value;

    if ((hasChecked || hasPriceValue) &&
      !facet.classList.contains('custom-product-type') &&
      !facet.classList.contains('custom-style')) {
      facet.setAttribute('open', '');
      summary.classList.add('is-open');

      display.classList.add('is-open');
      display.style.display = 'block';
      display.style.opacity = '1';
      display.style.maxHeight = 'none';

      return;
    }

    // ❌ Collapse facets with NO selected filters
    facet.removeAttribute('open');
    summary.classList.remove('is-open');

    display.classList.remove('is-open');
    display.style.display = 'none';
    display.style.opacity = '0';
    display.style.maxHeight = '0';
  });

  setTimeout(initFacetToggles, 100);
}

function initViewToggles() {
  const viewButtons = document.querySelectorAll('.filters-row__view');
  const productGrid = document.getElementById('product-grid');
  
  if (!viewButtons.length || !productGrid) return;
  
  viewButtons.forEach(button => {
    button.addEventListener('click', function() {
      const isRowView = this.classList.contains('link-row-view');
      
      viewButtons.forEach(btn => {
        btn.classList.remove('is-active');
      });
      
      this.classList.add('is-active');

      if (isRowView) {
        productGrid.classList.add('product-row-view');
      } else {
        productGrid.classList.remove('product-row-view');
      }
    });
  });
}

function initMobileFilters() {
  const mobileFilterBtn = document.querySelector('.mobile-filter-btn');
  const mobileSidebarClose = document.querySelector('.mobile-sidebar-close');
  const mainFilters = document.getElementById('main-collection-filters');
  const overlay = document.querySelector('.facted-overlay');
  
  if (mobileFilterBtn && mainFilters && overlay) {
    mobileFilterBtn.addEventListener('click', function() {
      mainFilters.classList.add('is-active');
      overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileSidebarClose && mainFilters && overlay) {
    mobileSidebarClose.addEventListener('click', function() {
      mainFilters.classList.remove('is-active');
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    });
  }
  
  if (overlay && mainFilters) {
    overlay.addEventListener('click', function() {
      mainFilters.classList.remove('is-active');
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    });
  }
}

function initProductLoading() {
  const $products = $('.product-grid');
  const $loadBtn = $('.load-more-btn');
  const $spinner = $('.custom-loader');
  const $perLoad = $('.products-per-load');
  
  if (!$products.length) return;
  
  let originalNextUrl = $products.data('next-url');
  let nextUrl = originalNextUrl;
  let originalProducts = $products.html();

  const urlParams = new URLSearchParams(window.location.search);
  const perPageParam = urlParams.get('per_page');

  function showSpinner() {
    if ($spinner.length) {
      $spinner.css('display', 'flex');
    }
  }

  function hideSpinner() {
    if ($spinner.length) {
      $spinner.hide();
    }
  }

  function updateURLParam(key, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.replaceState({}, '', url);
  }

  function resetToOriginal(callback) {
    setTimeout(function () {
      $products.html(originalProducts);
      nextUrl = originalNextUrl;
      if ($loadBtn.length) {
        $loadBtn.show();
      }
      if (callback) callback();
    }, 50);
  }

  function loadMoreProducts() {
    if (!nextUrl) {
      hideSpinner();
      return;
    }

    if ($loadBtn.length) {
      $loadBtn.hide();
    }

    $.get(nextUrl, nextPage => {
      const $newProducts = $(nextPage).find('.product-grid');
      $products.append($newProducts.html());

      filterNewProducts();

      // Apply color matching to the newly loaded products
      const container = document.getElementById('ProductGridContainer');
      if (container) {
        applyColorMatching(container);
      }

      nextUrl = $newProducts.data('next-url');

      const count = $products.find('.product-item').length;
      if ($perLoad.length && count >= 32) {
        $perLoad.val('32');
      }

      if (nextUrl && $loadBtn.length) {
        $loadBtn.show();
      }
      hideSpinner();
    }).fail(() => {
      hideSpinner();
      if ($loadBtn.length) {
        $loadBtn.show();
      }
    });
  }

  function loadAllProducts() {
    if (!nextUrl) {
      if ($perLoad.length) {
        $perLoad.val('all');
      }
      hideSpinner();
      return;
    }

    if ($loadBtn.length) {
      $loadBtn.hide();
    }

    $.get(nextUrl, nextPage => {
      const $newProducts = $(nextPage).find('.product-grid');
      $products.append($newProducts.html());

      filterNewProducts();

      // Apply color matching to the newly loaded products
      const container = document.getElementById('ProductGridContainer');
      if (container) {
        applyColorMatching(container);
      }

      nextUrl = $newProducts.data('next-url');

      if (nextUrl) {
        loadAllProducts();
      } else {
        if ($perLoad.length) {
          $perLoad.val('all');
        }
        filterNewProducts();
        hideSpinner();
      }
    }).fail(() => {
      hideSpinner();
      if ($loadBtn.length) {
        $loadBtn.show();
      }
    });
  }

  loadAllProductsForNewArrivals = function () {
    showSpinner();
    loadAllProducts();
  };

  if ($loadBtn.length) {
    $loadBtn.off('click').on('click', e => {
      e.preventDefault();
      showSpinner();
      loadMoreProducts();
    });
  }

  if ($perLoad.length) {
    $perLoad.off('change').on('change', function () {
      const val = $(this).val();
      updateURLParam('per_page', val);
      showSpinner();

      if (val === 'all') {
        resetToOriginal(loadAllProducts);
      } else if (val === '32') {
        resetToOriginal(function () {
          if ($products.find('.product-item').length < 32 && nextUrl) {
            loadMoreProducts();
          } else {
            hideSpinner();
          }
        });
      } else {
        resetToOriginal(hideSpinner);
      }
    });
  }

  document.addEventListener('click', function (event) {
    const filterItem = event.target.closest('.faceted-filter-item');
    if (filterItem) {
      const value = filterItem.getAttribute('data-value');
      document.querySelectorAll('.active-facets__button-inner').forEach(function (button) {
        if (button.getAttribute('data-value') === value) {
          button.click();
        }
      });
    }
  });

  if (perPageParam === 'all') {
    if ($perLoad.length) {
      $perLoad.val('all');
    }
    showSpinner();
    resetToOriginal(loadAllProducts);
  } else if (perPageParam === '32') {
    if ($perLoad.length) {
      $perLoad.val('32');
    }
    showSpinner();
    resetToOriginal(function () {
      if ($products.find('.product-item').length < 32 && nextUrl) {
        loadMoreProducts();
      } else {
        hideSpinner();
      }
    });
  }
}

// New Arrivals Filter
let loadAllProductsForNewArrivals = null;
let showNewOnly = false;

function filterNewProducts() {
  const items = document.querySelectorAll('#product-grid .grid__item');
  let visibleCount = 0;

  items.forEach(item => {
    const hasNewBadge = item.querySelector('.product__label--new, .badge-new-colors');

    if (showNewOnly) {
      if (hasNewBadge) {
        item.style.display = '';
        visibleCount++;
      } else {
        item.style.display = 'none';
      }
    } else {
      item.style.display = '';
      visibleCount++;
    }
  });

  const loadMoreBtn = document.querySelector('.load-more-btn');

  if (loadMoreBtn) {
    if (showNewOnly) {
      const totalLoaded = items.length;
      loadMoreBtn.style.display = visibleCount < totalLoaded ? 'none' : '';
    } else {
      loadMoreBtn.style.display = '';
    }
  }
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.new-arrivals');
  if (!btn) return;
  e.preventDefault();

  showNewOnly = !showNewOnly;
  btn.classList.toggle('active', showNewOnly);

  // Load all products first when New Arrivals is enabled
  if (showNewOnly && typeof loadAllProductsForNewArrivals === 'function') {
    const perLoad = document.querySelector('.products-per-load');
    if (perLoad) perLoad.value = 'all';

    loadAllProductsForNewArrivals();

    setTimeout(() => {
      filterNewProducts();
    }, 50);
  } else {
    filterNewProducts();
  }
});

function initializeAll() {
  initFacetToggles();
  initViewToggles();
  initMobileFilters();
  initProductLoading();

  // Apply saved color after page reload
  setTimeout(() => {
    const container = document.getElementById('ProductGridContainer');
    if (container) {
      applyColorMatching(container);
    }
  }, 500);
}

function debounce(fn, wait) {
  let t;
  const debouncedFn = (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
  debouncedFn.cancel = () => {
    clearTimeout(t);
  };
  return debouncedFn;
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

function removeFilterPanelIfNeeded() {
  if (window.innerWidth < 992) {
    const filterPanel = document.querySelector('.collection-filter-panel .facets-vertical-sort');
    if (filterPanel) {
      filterPanel.remove();
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initializeAll();
    removeFilterPanelIfNeeded();
    window.addEventListener('resize', removeFilterPanelIfNeeded);
  });
} else {
  initializeAll();
  removeFilterPanelIfNeeded();
  window.addEventListener('resize', removeFilterPanelIfNeeded);
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.attachEvents();
  }

  attachEvents() {
    const facetLink = this.querySelector('a');
    if (!facetLink) return;
    
    facetLink.removeEventListener('click', this.handleClick);
    facetLink.removeEventListener('keyup', this.handleKeyup);
    
    facetLink.addEventListener('click', (e) => this.handleClick(e));
    facetLink.addEventListener('keyup', (e) => this.handleKeyup(e));
    facetLink.setAttribute('role', 'button');
  }

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const form = this.closest('facet-filters-form');
    if (form && form.onActiveFilterClick) {
      form.onActiveFilterClick(event);
    }
  }

  handleKeyup(event) {
    if (event.code.toUpperCase() === 'SPACE') {
      event.preventDefault();
      this.handleClick(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);